<div class="forgot-password-container">
  <div class="forgot-password-left"></div>
  <div class="forgot-password-right">
    <div>
      <mat-stepper [linear]="isLinear" #stepper>
        <mat-step>
          <form [formGroup]="firstForm" subscriptSizing="dynamic" (keyup.enter)="onFirstSubmit()">
            <div class="header-form">
              <p>
                <button class="back-button" type="button" matStepperPrev i18n (click)="handleGotoLogin()">
                  <app-icons
                    [ariaHidden]="ariaHidden"
                    [ariaLabel]="ariaLabel"
                    [icon]="icon"
                    class="back-chevron"
                  ></app-icons
                  >{{ back }}
                </button>
              </p>
              <div class="steps">
                <p i18n>Step 1 of 3</p>
                <span i18n>Forgot password</span>
              </div>
            </div>
            <div class="heading">
              <h6 i18n>Forgot Password</h6>
              <p i18n>Enter the email of your account and we will send the email to reset your password.</p>
            </div>
            <div class="email">
              <app-input
                [formCntlName]="emailMat"
                [inputType]="emailInputType"
                [label]="emailLabel"
                [placeholder]="emailPlaceholder"
                [prefixInputIcon]="mailIcon"
                (keyup)="handleChange()"
              ></app-input>
              <mat-error *ngIf="emailMat.hasError('email') && !emailMat.hasError('required')" class="error" i18n
                >Please enter a valid email</mat-error
              >
              <mat-error *ngIf="emailMat.hasError('required') && emailMat.touched" class="error" i18n
                >Email is required</mat-error
              >
            </div>
            <app-button class="flow-cta" [fullWidth]="true" [disabled]="!firstForm.valid" (click)="onFirstSubmit()">
              <span i18n>Next</span>
            </app-button>
          </form>
        </mat-step>

        <mat-step>
          <form [formGroup]="secondForm" subscriptSizing="dynamic">
            <div class="header-form">
              <p>
                <button matStepperPrevious class="back-button" i18n>
                  <app-icons
                    [ariaHidden]="ariaHidden"
                    [ariaLabel]="ariaLabel"
                    [icon]="icon"
                    class="back-chevron"
                  ></app-icons>
                  Back
                </button>
              </p>

              <div class="steps">
                <p i18n>Step 2 of 3</p>
                <span i18n>Forgot password</span>
              </div>
            </div>
            <div class="heading">
              <h6 i18n>Check your Mail</h6>
              <p i18n class="mail-check-p">
                We have sent a 6-digit code to <em>{{ emailMat.value }}</em
                >. Make sure you enter the correct code.
              </p>
            </div>
            <div class="otp">
              <ng-otp-input #otpInput (onInputChange)="onOtpChange($event)" [config]="{ length: 6 }"></ng-otp-input>
            </div>
            <mat-error *ngIf="otpError" class="error" i18n> Wrong code. Try again </mat-error>
            <app-button class="flow-cta" [fullWidth]="true" [disabled]="submitDisabled" (click)="stepper.next()">
              <span i18n>Continue</span>
            </app-button>
            <p class="resend-code" i18n>
              Didn't receive code?
              <a (click)="resendOtp()">Resend Code</a>
            </p>
          </form>
        </mat-step>

        <mat-step>
          <form [formGroup]="thirdForm">
            <div class="header-form">
              <p>
                <button matStepperPrevious class="back-button" i18n>
                  <app-icons
                    [ariaHidden]="ariaHidden"
                    [ariaLabel]="ariaLabel"
                    [icon]="icon"
                    class="back-chevron"
                  ></app-icons>
                  Back
                </button>
              </p>
              <div class="steps">
                <p i18n>Step 3 of 3</p>
                <span i18n>Forgot password</span>
              </div>
            </div>
            <div>
              <app-template-password
                [title]="title"
                [desc]="desc"
                [showExistingPassword]="false"
                [showSubmitButton]="true"
                [showSaveButton]="false"
                [showCancelButton]="false"
                (newPasswordSubmitted)="emittedPassword($event)"
                (onSubmit)="submitThirdForm()"
              ></app-template-password>
            </div>
          </form>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
</div>
